<script setup lang="ts">
import { onBeforeMount } from 'vue';
import { useDutyChangePreview } from '@/rennovation/planning-view/composables/useDutyChangePreview';
import DutyChangePreviewBanner from '@/rennovation/planning-view/components/Layout/Modals/Preview/DutyChangePreviewBanner.vue';

const { showBanner, violationsCount, changesCount, cancelPreview, publishPreview, loadPreview } = useDutyChangePreview();
interface Props {
	hasEnvBanner: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	hasEnvBanner: false,
});
onBeforeMount(loadPreview);
</script>

<template>
	<div>
		<DutyChangePreviewBanner
			v-if="showBanner"
			:violations="violationsCount"
			:changes="changesCount"
			:has-env-banner="props.hasEnvBanner"
			@cancel="cancelPreview"
			@publish="publishPreview"
		/>
	</div>
</template>
